var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.wrapperComponent,
    {
      tag: "component",
      attrs: { "offset-top": _vm.offsetTop, "offset-bottom": _vm.offsetBottom },
      on: { "on-change": _vm.handleAffixStateChange }
    },
    [
      _c("div", { class: _vm.prefix + "-wrapper", style: _vm.wrapperStyle }, [
        _c(
          "div",
          { class: "" + _vm.prefix },
          [
            _c("div", { class: _vm.prefix + "-ink" }, [
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showInk,
                    expression: "showInk"
                  }
                ],
                class: _vm.prefix + "-ink-ball",
                style: { top: _vm.inkTop + "px" }
              })
            ]),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06845ca5", { render: render, staticRenderFns: staticRenderFns })
  }
}